import {NgModule} from '@angular/core';
import {TextToLinkPipe} from './text-to-link/text-to-link';
import {TextNewLinesPipe} from './text-new-lines/text-new-lines';
import {TareasPipe} from './tareas/tareas';
import {TareasOrdenPipe} from './tareas-orden/tareas-orden';
import {PedidosPipe} from './pedidos/pedidos';
import {AlbaranesPipe} from './albaranes/albaranes';
import {UsuariosPipe} from './usuarios/usuarios';
import {SizePipe} from './size/size';
import {MenuPipe} from './menu/menu';
import {AlmacenesPipe} from './almacenes/almacenes';
import {InventariosPipe} from './inventarios/inventarios';
import {RevisionesPipe} from './revisiones/revisiones';
import {AlmacenesOrdenPipe} from './almacenes-orden/almacenes-orden';
import {ProductosFavoritosPipe} from './productos-favoritos/productos-favoritos';
import {CatalogoPipe} from './catalogo/catalogo';
import {TareasChecklistPipe} from './tareas-checklist/tareas-checklist';
import {RecargasPipe} from './recargas/recargas';
import {TutorialesPipe} from './tutoriales/tutoriales';
import {EscandallosPipe} from './escandallos/escandallos';
import {PagosPipe} from './pagos/pagos';
import {CierresPipe} from './cierres/cierres';
import {GastosPipe} from './gastos/gastos';
import {VacacionesPipe} from './vacaciones/vacaciones';
import {PedidosFavoritosPipe} from './pedidos-favoritos/pedidos-favoritos';
import {IntvalPipe} from './intval/intval';
import {PartidasPipe} from './partidas/partidas';
import {LineasPedidoPipe} from './lineas-pedido/lineas-pedido';
import {CuadrantePipe} from './cuadrante/cuadrante';
import {MultisesionPipe} from './multisesion/multisesion';
import {ComunicacionPipe} from './comunicacion/comunicacion';
import {OrdenProPipe} from './orden-pro/orden-pro';
import {CarpetasPipe} from './carpetas/carpetas';
import {PlataformasPipe} from './plataformas/plataformas';
import {tareasChecklistSubfamPipe} from "./tareas-checklist/tareas-checklist-subfam";
import {tareasChecklistFamPipe} from "./tareas-checklist/tareas-checklist-fam";
import {ModelosChecklistPipe} from './modelos-checklist/modelos-checklist';
import {SearchPipe} from './search/search';
import {TraspasosPipe} from './traspasos/traspasos';
import {EtiquetadoPipe} from './etiquetado/etiquetado';
import {DispositivosPipe} from './dispositivos/dispositivos';
import {MermasPipe} from './mermas/mermas';
import {DepartamentosPipe} from './departamentos/departamentos';
import {SolicitudesPipe} from './solicitudes/solicitudes';
import {UsuariosContratoPipe} from './solicitudes/usuarios-contrato';
import {MaquinasPipe} from './maquinas/maquinas';
import {FestivosPipe} from './festivos/festivos';
import {ProductosIvaPipe} from './albaranes/productos-iva';

const declarationsExports = [
  TextToLinkPipe,
  TextNewLinesPipe,
  TareasPipe,
  TareasOrdenPipe,
  PedidosPipe,
  AlbaranesPipe,
  UsuariosPipe,
  SizePipe,
  MenuPipe,
  AlmacenesPipe,
  InventariosPipe,
  RevisionesPipe,
  AlmacenesOrdenPipe,
  ProductosFavoritosPipe,
  CatalogoPipe,
  TareasChecklistPipe,
  RecargasPipe,
  TutorialesPipe,
  EscandallosPipe,
  PagosPipe,
  CierresPipe,
  EscandallosPipe,
  GastosPipe,
  VacacionesPipe,
  PedidosFavoritosPipe,
  IntvalPipe,
  PartidasPipe,
  LineasPedidoPipe,
  CuadrantePipe,
  MultisesionPipe,
  ComunicacionPipe,
  OrdenProPipe,
  CarpetasPipe,
  PlataformasPipe,
  tareasChecklistSubfamPipe,
  tareasChecklistFamPipe,
  ModelosChecklistPipe,
  SearchPipe,
  TraspasosPipe,
  EtiquetadoPipe,
  DispositivosPipe,
  MermasPipe,
  DepartamentosPipe,
  SolicitudesPipe,
  UsuariosContratoPipe,
  MaquinasPipe,
  FestivosPipe,
  ProductosIvaPipe,
];

@NgModule({
  declarations: [...declarationsExports],
  imports: [],
  exports: [...declarationsExports]
})
export class PipesModule {
}



// WEBPACK FOOTER //
// ./src/pipes/pipes.module.ts